module.exports = __webpack_public_path__ + "static/media/climate-hub-logo.6e1b1587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/climate-hub-logo.png
// module id = 2546
// module chunks = 0